<template>
  <span v-show="$store.getters['app/overlays'].show_start_selector_overlay">
    <img  draggable="false" id="text_background" src="./../assets/images/Asset 36.png" alt="">
    <img  draggable="false" @click="goToHengelen()" id="hengel_btn" src="./../assets/images/Asset 35.png" alt="">
    <img  draggable="false" @click="goToGolven()" id="golven_btn" src="./../assets/images/Asset 34.png" alt="">
    <img  draggable="false" @click="goToHome()" id="top_quit_btn" src="./../assets/images/Asset 31.png" alt="">
  </span>
</template>

<script>
export default {
  name: "GameSelect",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToHome() {
      this.$router.push('/');
      this.$store.dispatch('app/asyncUpdateOverlay', {
          show_start_menu_overlay: true,
          show_start_selector_overlay: false,
      });
    },

    goToHengelen() {
      this.$router.push('/hengelen');
    },

    goToGolven() {
      this.$router.push('/golven');
    },
  },

  computed: {}
};
</script>

<style >
#hengel_btn {
  cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
	position: absolute;
	margin-top: 14%;
	left: 36%;
  width: 30%;
}

#golven_btn {
  cursor: url('./../assets/cursor/material-wood-pointer.png'), default;	
	position: absolute;
	margin-top: 25%;
	left: 36%;
  width: 30%;
}

#hengel_btn:hover {
  opacity: 0.7;
}
#golven_btn:hover {
  opacity: 0.7;
}
</style>


